/** @module @csi/widget/UserCollection */
define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"dijit/_Container",
	"dijit/_WidgetBase",
	"dijit/form/DropDownButton",
	"underscore",
	"csi/widget/Container",
	"csi/widget/UserIcon"
], function(declare,Memory,_Container,_WidgetBase,DropDownButton,_,Container,UserIcon) {
	
	const MAX_USER_ICONS = 6;
	
	return declare([_WidgetBase, _Container], {
		baseClass: "csi-user-collection",
		
		/** @property {Cache} cache - cache to use to get data */
		cache: null,
		
		/** @property {string[]} userUrls - URLs of users to show */
		userUrls: null,
		
		postCreate: function() {
			this.inherited(arguments);
			
			const userUrls = this.userUrls;
			const n = userUrls.length;
			if (!n) {
				return;
			}
			
			const cache = this.cache;
			const data = [];
			
			_.each(userUrls, function(userUrl, i) {
				if (i >= MAX_USER_ICONS) {
					data.push({userUrl: userUrl});
				} else {
					this.addChild(new UserIcon({
						cache: cache,
						userUrl: userUrl
					}));
				}
			}, this);
			
			if (data.length) {
				const store = new Memory({
					idProperty: "userUrl",
					data: data
				});
				
				const dropDown = new Container({
					"class": this.baseClass + "-drop-down",
					store: store,
					widgetClass: UserIcon,
					widgetParams: {
						allowName: true,
						allowTooltip: false,
						cache: cache
					},
					widgetProperties: [store.idProperty]
				});
				
				this.addChild(new DropDownButton({
					"class": this.baseClass + "-button csi-drop-down-button-hide-arrow",
					dropDown: dropDown,
					label: "+" + data.length 
				}))
			}
		}
	});
});